<template>
  <div v-if="responseService">
    <v-card class="assignment-card" elevation="2">
      <v-card-title class="section-title">
        Asignación masiva
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
        <div class="affiliates-container">
          <div class="affiliates-count">
            <label for="affiliatesCount">{{ $t('starAssignment.label.amountAffiliates.title') }}</label>
          </div>
          <div>
            <label class="affiliates-number">{{ affiliatesCount }}</label>
          </div>
        </div>
        <v-col cols="12">
          <v-simple-table
            class="table-cell small-table"
          >
            <thead>
              <tr>
                <th
                  scope="col"
                  class="table-cell small-column"
                  style="
                    color: #6e17a5;
                    text-align: center;
                    font-weight: 500;
                    font-size: 16px;
                  "
                >
                  {{ $t('starAssignment.label.table.categories') }}
                </th>
                <th
                  scope="col"
                  class="table-cell small-column"
                  style="
                    color: #6e17a5;
                    text-align: center;
                    font-weight: 500;
                    font-size: 16px;
                  "
                >
                  {{ $t('starAssignment.label.table.amount') }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in typeCategory" :key="index">
                <td class="table-cell">{{ item.categoryName }}</td>
                <td class="table-cell">
                  <input
                    type="number"
                    v-model.number="item.currentCount"
                    min="0"
                    class="inputCantidad"
                    @input="validateAffiliatesCount(index)"
                    placeholder="0"
                  />
                </td>
              </tr>
            </tbody>
          </v-simple-table>
        </v-col>
      </v-row>
        </v-container>
      </v-card-text>
    </v-card>

    <v-dialog v-model="dialog" max-width="600px">
      <v-card class="container-model">
        <v-btn
          icon
          class="close-button"
          @click="closeDialog"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-col cols="12" md="12" sm="6">
          <img
            src="https://ibliss-icons-prod.s3.us-east-1.amazonaws.com/marca_empresarial/image-welcomeDefault.png"
            class="custom-img"
          />
        </v-col>
        <h2 class="custom-title">{{ $t('starAssignment.label.title') }}</h2>
        <h3 class="custom-text">{{ $t('starAssignment.label.star.assign') }}</h3>
        <v-row no-gutters class="starDialog">
          <v-col
            no-gutters
            class="d-flex justify-center"
            v-for="(item, index) in selectedItems"
            :key="index"
          >
            <v-card class="cardStyle">
              <div class="d-flex flex-no-wrap justify-space-around">
                <div>
                  <v-card-title>{{ item.categoryName }}</v-card-title>
                  <v-card-title class="text-h5">{{
                    item.currentCount
                  }}</v-card-title>
                </div>
                <v-avatar class="avatarStyle" size="60">
                  <v-img
                    :src="item.icon"
                    max-width="40"
                    max-height="40"
                  ></v-img>
                </v-avatar>
              </div>
            </v-card>
          </v-col>
        </v-row>
        <v-card-actions class="justify-space-around">
          <v-btn @click="saveChanges" rounded color="primary">
            {{ $t('button.accept.text') }}
          </v-btn>
          <v-btn
            @click="cancelDialog"
            rounded
            style="color: #ffffff; background-color: #757575">
            {{ $t('button.cancel.text') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <template>
      <div style="height: 50px">
        <v-btn
          fixed
          bottom
          right
          rounded
          :class="{
            'disabled-btn': !isButtonEnabled,
            'primary-btn': isButtonEnabled,
          }"
          :color="isButtonEnabled ? 'primary' : 'grey'"
          :disabled="!isButtonEnabled"
          @click="isButtonEnabled ? openModal() : null"
        >
          {{ $t('button.assign') }}
        </v-btn>
      </div>
    </template>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import i18n from '@/plugins/i18n';
import Swal from "sweetalert2";

import {
  STARASSIGNMENT_M,
  ACTION_POST_STARASSIGNMENT_ALL,
  ACTION_GET_STARASSIGNMENT_TYPE_CATEGORY,
} from "@/views/star_assignment/store/types/types.js";

export default {
  props: {
    typeCategory: {
      type: Array,
      default: () => [],
    },
    affiliatesCount: {
      type: Number,
    },
    maxRecognitionCount: {
      type: Number,
    },
    shapeTypeId: {
      type: Number,
    },
    redeemDate: {},
  },
  data() {
    return {
      dialog: false,
      selectedItems: [],
      responseService: null,
    };
  },
  computed: {
    maxAffiliatesCount() {
      return this.maxAffiliates;
    },
    isButtonEnabled() {
      return this.typeCategory.some((item) => item.currentCount > 0);
    },
  },
  async mounted() {
    this.responseService = await this.getActionTypeCategory();
  },
  methods: {
    validateAffiliatesCount(index) {
      const item = this.typeCategory[index];
      if (item.currentCount > item.maxRecognitionCount) {
        item.currentCount = item.maxRecognitionCount;
        Swal.fire({
          icon: "error",
          title: i18n.t('starAssignment.label.limitAssign.title'),
          text: i18n.t('starAssignment.label.limitAssign.text').replace('maxStars', item.maxRecognitionCount)
        });
      } else if (item.currentCount < 0) {
        item.currentCount = 0;
      }
    },

    openModal() {
      if (!this.shapeTypeId) {
        Swal.fire({
          icon: "error",
          title: i18n.t('starAssignment.label.typeStar.required'),
          confirmButtonColor: "#6E17A5",
        });
        return;
      }

      if (!this.redeemDate) {
        Swal.fire({
          icon: "error",
          title: i18n.t('starAssignment.label.date.required'),
          confirmButtonColor: "#6E17A5",
        });
        return;
      }
      this.selectedItems = this.typeCategory
        .filter((item) => item.currentCount > 0)
        .map((item) => ({
          ...item,
          icon: item.icon,
        }));
      this.dialog = true;
    },

    closeDialog() {
      this.dialog = false;
    },

    async cancelDialog() {
      await Swal.fire({
        position: "top-end",
        icon: "info",
        title: i18n.t('label.delete.cancel'),
        showConfirmButton: false,
        timer: 2500,
      });
      this.dialog = false;
    },

    async saveChanges() {
      try {
        const transformedData = {
          redeemDate: this.redeemDate,
          shapeTypeId: this.shapeTypeId,
          categories: this.selectedItems.map((item) => ({
            categoryId: item.recognitionCategoryId,
            monetizedObjectCount: item.currentCount,
            value: item.value,
          })),
        };

        await this.postStarAssignmentAll(transformedData);

        this.closeDialog();
        this.$emit("saved", "Los datos se han guardado exitosamente.");
      } catch (error) {
        console.error("Error al guardar los datos:", error);
      }
    },

    ...mapActions({
      postStarAssignmentAll: `${STARASSIGNMENT_M}${ACTION_POST_STARASSIGNMENT_ALL}`,
      getActionTypeCategory: `${STARASSIGNMENT_M}${ACTION_GET_STARASSIGNMENT_TYPE_CATEGORY}`,
    }),
  },
};
</script>

<style scoped>
.fixed {
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 1000;
}

.v-dialog .v-card {
  max-width: 600px;
}

.cardStyle {
  border-radius: 16px;
  box-shadow: 0 4px 18px rgba(110, 23, 165, 0.1) !important;
  border: 1px solid #f2b37b;
  width: 200px;
  min-height: 110px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 4px;
}

.avatarStyle {
  background-color: white;
}

.affiliates-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  gap: 8px;
  padding: 8px 0 24px;
}

.affiliates-count {
  color: #6e17a5;
  font-size: 16px;
  font-weight: 500;
}

.affiliates-number {
  font-size: 28px;
  font-weight: 700;
  color: #ff7900;
}

.small-table {
  width: 100%;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 4px 18px rgba(110, 23, 165, 0.08) !important;
}

.table-cell {
  text-align: center;
  border: none;
  padding: 12px 8px;
  font-size: 15px;
}

.small-column {
  color: #6e17a5;
  text-align: center;
  font-weight: 600;
  font-size: 16px;
}

.inputCantidad {
  text-align: center;
  width: 80px;
  min-height: 34px;
  font-size: 15px;
  font-weight: 500;
  border: 1px solid #6e17a5;
  border-radius: 8px;
  padding: 6px;
}

.disabled-btn {
  background-color: #ccc !important;
  color: #fff !important;
}

.custom-title {
  color: #6e17a5;
  text-align: center;
  font-size: 1.6rem;
  margin: 8px 0;
}

.custom-text {
  font-size: 16px;
  color: #6e17a5;
  font-weight: 300;
  text-align: center;
  margin-bottom: 4px;
}

.custom-img {
  width: 150px;
  height: auto;
  display: block;
  margin: 0 auto 12px;
}

.close-button {
  position: absolute;
  top: 12px;
  right: 12px;
  color: #6e17a5 !important;
  background: none;
  border: none;
  cursor: pointer;
}

.starDialog {
  padding: 0 24px;
  display: flex;
  justify-content: center;
  gap: 12px;
  flex-wrap: wrap;
}

.container-model {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 24px;
  color: #6e17a5;
  border-radius: 20px;
  overflow: hidden;
}

.assignment-card {
  border-radius: 16px;
  margin: 16px 0;
  overflow: hidden;
}

.section-title {
  color: #6e17a5;
  font-size: 1.2rem;
  font-weight: 600;
  padding: 12px 0 6px;
  margin: 0;
  border-bottom: 2px solid #ff7900;
  word-break: auto-phrase;
}

@media screen and (max-width: 600px) {
  .cardStyle {
    width: 100%;
    padding: 8px;
  }

  .custom-title {
    font-size: 24px;
  }

  .custom-text {
    font-size: 14px;
  }

  .v-card-title {
    font-size: 1rem;
  }

  .small-table {
    max-width: 100%;
  }
}
</style>
